<template>
    <modal v-bind:show.sync="show" ref="modal">
        <div slot="header">
            <h3 class="panel-title f-s-5">{{ trans('Cancel Subscription') }}</h3>
        </div>
        <div>
            <div class="form-group" v-bind:class="{'has-error': errors.has('reason')}">
                <label>
                    {{ trans('Reason') }}
                    <input class="input__field" type="text" v-model="reason" v-bind:placeholder="trans('Reason for cancellation')">
                </label>
            </div>
            <div v-if="errors.has('reason')" class="form-help">{{ errors.get('reason') }}</div>
        </div>
        <div slot="footer">
            <div class="row row-collapse">
                <div class="column">
                    <button type="button" class="btn btn-alert m-r-3" v-on:click="cancelSubscription" v-bind:class="{'btn-loading': loading}">
                        {{ trans('Cancel Subscription') }}
                        <div v-if="loading" class="loader">
                            <div class="chartdonut chartdonut_animation--rotate-tiny chartdonut--tiny">
                                <svg class="i-stroke-bright" width="24" height="24"><g><circle class="icon" cx="50%" cy="50%" r="10" stroke-width="2" fill="none" stroke-dashoffset="5"></circle></g></svg>
                            </div>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    </modal>
</template>
<script>
import Errors from '../../errors';
import Modal from '../modals/Modal.vue';

export default {
    components: {
        Modal
    },
    data() {
        return {
            show: false,
            orderId: null,
            reason: '',
            loading: false,
            errors: new Errors()
        }
    },
    methods: {
        cancelSubscription() {
            this.loading = true;
            this.errors.clear();

            window.axios
                .post(Kourses.apiBaseUrl + '/orders/' + this.orderId + '/cancel', { reason: this.reason })
                .then(() => {
                    this.loading = false;
                    this.show = false;
                    this.reset();
                    this.$emit('subscription:cancelled', this.orderId);
                })
                .catch((error) => {
                    this.loading = false;
                    if (error.response && error.response.data && error.response.data.errors) {
                        this.errors.record(error.response.data.errors);
                    }
                });
        },
        reset() {
            this.reason = '';
            this.errors.clear();
        }
    }
}
</script>